export default {
    DROP_HERE_OR: "Перетащите файл сюда или",
    SELECT_MANUALLY: "выберите вручную"
};
